<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Peter Robinson Leaver was born in 1946 and was educated at Queen Elizabeth’s Grammar School in Blackburn, Lancashire. He subsequently attained a BSc in Earth and Environmental Sciences with the Open University whilst enjoying a career in the Ministry of Defence working with all three-armed services. He fell in love with Gibraltar during a bird-surveying expedition with the RAF, observing migrating birds of prey as they crossed over from Africa. He returned on several occasions to research material for <em>Siege XV</em> and began writing as a hobby. Now retired from his ‘proper job’, Peter works part-time for a national wine company, enjoying the fruits of his labours. He is unmarried and lives in the Wiltshire countryside but remains a passionate Blackburn Rovers fan.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?3683be1f